/** Must match ACCOUNT_DEACTIVATED_CODE in the backend AccountDeactivatedError. */
export const ACCOUNT_DEACTIVATED_CODE = 'AccountDeactivated';

export const isAccountDeactivatedError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as { code?: unknown }).code === ACCOUNT_DEACTIVATED_CODE;
